import Swiper, { Autoplay } from 'swiper'
Swiper.use([Autoplay])
import 'swiper/css'

export function anyQuestions(element: HTMLElement) {
  const slider = element.querySelector('.swiper') as HTMLElement
  let width = window.innerWidth

  const swiper = new Swiper(slider, {
    grabCursor: true,
    breakpoints: {
      0: {
        slidesPerView: 1.25,
        spaceBetween: 10,
        slidesOffsetAfter: width * 0.1
      },
      768: {
        slidesPerView: 1.25,
        slidesOffsetAfter: 0
      },
      992: {
        slidesPerView: 2.5
      },
      1200: {
        slidesPerView: 2.5,
        spaceBetween: 0
      },
      1920: {
        slidesPerView: 2.5,
        spaceBetween: 0
      }
    }
  })

  console.log(swiper)

  window.addEventListener('resize', () => {
    width = window.innerWidth
    swiper.update()
  })
}
